<label
  class="btn-area"
  [class.disabled]="disabled"
  [class.dragover]="isDragging"
  [ngClass]="'color-primary'"
  [ngStyle]="{ 'border-color': 'var(--color-primary)' }"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
  >
  <!-- Show upload button if no file is selected -->
  @if (!fileName) {
    <div class="upload-container">
      <div class="upload-button" [class.loading]="loading">
        @if (!loading) {
          <span>
            <i class="pi pi-cloud-upload"></i>
            {{ isDragging ? ('COMMON.BUTTONS.DROP_FILE_HERE' | translate) : ('COMMON.BUTTONS.SELECT_OR_DROP_FILE' | translate) }}
          </span>
        }
        @if (loading) {
          <i class="pi pi-spin pi-spinner color-primary" style="font-size: 2rem"></i>
        }
      </div>
    </div>
  }

  <!-- Show file icon (with download link) and remove icon when file exists -->
  @if (fileName) {
    <div class="file-container" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" tabindex="0" role="button">
      <!-- Wrap icon and text in a container for horizontal alignment -->
      <div class="file-info">
        <a [href]="fileName" target="_blank" class="file-icon">
          <i [ngClass]="getFileIconClass(fileName)"></i>
        </a>
        <span class="file-type">{{ getFileType(fileName) }}</span>
      </div>
      <a href="#" class="custom-delete-button" (click)="reset($event)">
        <i class="pi pi-trash"></i> <b>{{ 'COMMON.BUTTONS.DELETE' | translate }}</b>
      </a>
    </div>
  }

  <!-- The file input is inside the label, so clicking the label will trigger it -->
  <input
    type="file"
    #fileInput
    [disabled]="disabled || loading || fileName"
    (change)="onFileSelected($event)"
    accept="image/*,video/*,.txt,.pdf,.doc,.docx,.xls,.xlsx"
    style="position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(1px, 1px, 1px, 1px); white-space: nowrap"
    />
</label>
